export default "__VITE_ASSET__DQWjhNbu__"